/*
 * Nutriop Longevity - Swiss Protocol Collection JS
 * Version: 4.2 - Shelf Layout + Protocol Bundles + Urgency Ribbon
 * Theme: FLUX 1.9
 *
 * 1. FLUX PubSub  2. Filter (shelf-level)  3. Mobile Drawer
 * 4. Subscription Toggle  5. Add-to-Cart  6. Quick View
 * 7. Analytics  8. Bundle Timer + Urgency Ribbon + Multi-Item ATC
 */

/* -------------------------------------------
   1. FLUX PUB/SUB - Ensure availability
   ------------------------------------------- */
if (typeof window.publish === 'undefined' || typeof window.PUB_SUB_EVENTS === 'undefined') {
  window.PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    variantChange: 'variant-change',
    cartError: 'cart-error'
  };

  const _subs = {};
  window.subscribe = window.subscribe || function(ev, cb) {
    if (!_subs[ev]) _subs[ev] = [];
    _subs[ev].push(cb);
    return () => { _subs[ev] = _subs[ev].filter(c => c !== cb); };
  };
  window.publish = window.publish || function(ev, data) {
    if (!_subs[ev]) return;
    _subs[ev].forEach(cb => { try { cb(data); } catch(e) { console.error(e); } });
  };
}


/* ===========================================
   2. FILTER & SORT CONTROLLER - SHELF-LEVEL
   =========================================== */
class NpFilterSort {
  constructor() {
    this.filterBar = document.querySelector('[data-filter-bar]');
    if (!this.filterBar) return;

    this.pills = this.filterBar.querySelectorAll('.np-filter-pill');
    this.sortWrapper = this.filterBar.querySelector('[data-sort-wrapper]');
    this.sortTrigger = this.filterBar.querySelector('[data-sort-trigger]');
    this.sortMenu = this.filterBar.querySelector('[data-sort-menu]');
    this.sortDisplay = this.filterBar.querySelector('[data-sort-display]');
    this.sortOptions = this.filterBar.querySelectorAll('.np-sort__option');

    this.activeFilter = 'all';
    this.init();
  }

  init() {
    this.bindFilterPills();
    this.bindSort();
  }

  bindFilterPills() {
    this.pills.forEach(pill => {
      pill.addEventListener('click', () => {
        this.pills.forEach(p => {
          p.classList.remove('np-filter-pill--active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('np-filter-pill--active');
        pill.setAttribute('aria-selected', 'true');

        this.activeFilter = pill.dataset.filter;
        this.applyFilter(this.activeFilter);
        NpAnalytics.track('filter_applied', { filter: this.activeFilter });
      });
    });
  }

  /**
   * SHELF-LEVEL FILTERING
   * ---------------------
   *   Filter Pill          ->  Shelf data-category
   *   ---------------------------------------------
   *   "All"                ->  show all shelves
   *   "The NAD+ Engine"    ->  "energy"   (Shelf 1)
   *   "Life Stacks"        ->  "stacks"   (Shelf 2)
   *   "Senolytics"         ->  "repair"   (Shelf 3)
   *   "Neuro-Performance"  ->  "brain"    (Shelf 4)
   *   "Bundles & More"     ->  "bundles"  (Shelf 5: Protocol Bundles)
   *   Catch-all            ->  "additional" (Shelf 6: only shows under All)
   */
  applyFilter(filter) {
    var shelves = document.querySelectorAll('.np-shelf[data-category]');

    shelves.forEach(function(shelf) {
      if (filter === 'all' || shelf.getAttribute('data-category') === filter) {
        shelf.style.display = '';
        shelf.removeAttribute('hidden');
      } else {
        shelf.style.display = 'none';
        shelf.setAttribute('hidden', '');
      }
    });

    this.updateVisibleCount(filter);
  }

  updateVisibleCount(filter) {
    var countEl = this.filterBar.querySelector('.np-filter-pill[data-filter="all"] .np-filter-pill__count');
    if (!countEl) return;

    if (filter === 'all') {
      var totalCards = document.querySelectorAll('.np-shelf .np-card').length;
      countEl.textContent = totalCards || countEl.dataset.total || countEl.textContent;
      return;
    }

    var visibleCards = 0;
    document.querySelectorAll('.np-shelf[data-category="' + filter + '"]').forEach(function(shelf) {
      visibleCards += shelf.querySelectorAll('.np-card').length;
    });
    if (!countEl.dataset.total) {
      countEl.dataset.total = countEl.textContent;
    }
    countEl.textContent = visibleCards;
  }

  bindSort() {
    if (!this.sortTrigger || !this.sortWrapper) return;

    this.sortTrigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = this.sortWrapper.dataset.open === 'true';
      this.sortWrapper.dataset.open = isOpen ? 'false' : 'true';
      this.sortTrigger.setAttribute('aria-expanded', !isOpen);
    });

    document.addEventListener('click', () => {
      this.sortWrapper.dataset.open = 'false';
      this.sortTrigger.setAttribute('aria-expanded', 'false');
    });

    this.sortOptions.forEach(opt => {
      opt.addEventListener('click', () => {
        const value = opt.dataset.sortValue;
        this.sortOptions.forEach(o => o.classList.remove('np-sort__option--active'));
        opt.classList.add('np-sort__option--active');

        this.sortDisplay.textContent = opt.textContent;
        this.sortWrapper.dataset.open = 'false';

        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        window.location.href = url.toString();
      });
    });
  }
}


/* ===========================================
   3. MOBILE DRAWER CONTROLLER - SHELF-LEVEL
   =========================================== */
class NpMobileDrawer {
  constructor() {
    this.drawer = document.querySelector('[data-filter-drawer]');
    if (!this.drawer) return;

    this.trigger = document.querySelector('[data-mobile-filter-trigger]');
    this.overlay = this.drawer.querySelector('[data-drawer-overlay]');
    this.closeBtn = this.drawer.querySelector('[data-drawer-close]');
    this.applyBtn = this.drawer.querySelector('[data-drawer-apply]');
    this.clearBtn = this.drawer.querySelector('[data-drawer-clear]');
    this.mobilePills = this.drawer.querySelectorAll('[data-mobile-filter]');
    this.mobileSort = this.drawer.querySelectorAll('input[name="mobile-sort"]');

    this.init();
  }

  init() {
    if (!this.trigger) return;

    this.trigger.addEventListener('click', () => this.open());
    this.overlay?.addEventListener('click', () => this.close());
    this.closeBtn?.addEventListener('click', () => this.close());

    this.mobilePills.forEach(pill => {
      pill.addEventListener('click', () => {
        this.mobilePills.forEach(p => p.classList.remove('np-drawer__pill--active'));
        pill.classList.add('np-drawer__pill--active');
      });
    });

    this.applyBtn?.addEventListener('click', () => {
      const activePill = this.drawer.querySelector('.np-drawer__pill--active');
      const filter = activePill?.dataset.mobileFilter || 'all';

      const sortInput = this.drawer.querySelector('input[name="mobile-sort"]:checked');
      const sort = sortInput?.value || 'manual';

      // Sync desktop pills
      const desktopPills = document.querySelectorAll('.np-filter-pill');
      desktopPills.forEach(p => {
        p.classList.remove('np-filter-pill--active');
        p.setAttribute('aria-selected', 'false');
        if (p.dataset.filter === filter) {
          p.classList.add('np-filter-pill--active');
          p.setAttribute('aria-selected', 'true');
        }
      });

      // Apply SHELF-LEVEL filter
      var shelves = document.querySelectorAll('.np-shelf[data-category]');
      shelves.forEach(function(shelf) {
        if (filter === 'all' || shelf.getAttribute('data-category') === filter) {
          shelf.style.display = '';
          shelf.removeAttribute('hidden');
        } else {
          shelf.style.display = 'none';
          shelf.setAttribute('hidden', '');
        }
      });

      if (sort !== 'manual') {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort);
        window.location.href = url.toString();
        return;
      }

      this.close();
    });

    this.clearBtn?.addEventListener('click', () => {
      this.mobilePills.forEach(p => p.classList.remove('np-drawer__pill--active'));
      this.mobilePills[0]?.classList.add('np-drawer__pill--active');
      const defaultSort = this.drawer.querySelector('input[name="mobile-sort"][value="manual"]');
      if (defaultSort) defaultSort.checked = true;
    });
  }

  open() {
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('np-drawer-open');
  }

  close() {
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('np-drawer-open');
  }
}


/* ===========================================
   4. SUBSCRIPTION TOGGLE CONTROLLER
      V5 Neon Protocol card design classes
   =========================================== */
class NpSubscriptionToggle {
  constructor() {
    this.toggles = document.querySelectorAll('[data-purchase-toggle]');
    this.init();
  }

  init() {
    this.toggles.forEach(toggle => {
      const card = toggle.closest('.np-card');
      const subBtn = toggle.querySelector('[data-toggle="subscribe"]');
      const oneBtn = toggle.querySelector('[data-toggle="onetime"]');
      const pricesSub = card.querySelector('[data-price-subscribe]');
      const pricesOne = card.querySelector('[data-price-onetime]');
      const sellingPlanInput = card.querySelector('[data-selling-plan-input]');
      const atcText = card.querySelector('[data-atc-text]');

      if (!subBtn || !oneBtn) return;

      subBtn.addEventListener('click', () => {
        subBtn.classList.add('np-v5__toggle-opt--active');
        oneBtn.classList.remove('np-v5__toggle-opt--active');
        if (pricesSub) pricesSub.style.display = '';
        if (pricesOne) pricesOne.style.display = 'none';
        if (sellingPlanInput) sellingPlanInput.disabled = false;
        if (atcText) atcText.textContent = 'Start Subscription';
        NpAnalytics.track('toggle_subscribe', { product: card.dataset.productHandle });
      });

      oneBtn.addEventListener('click', () => {
        oneBtn.classList.add('np-v5__toggle-opt--active');
        subBtn.classList.remove('np-v5__toggle-opt--active');
        if (pricesOne) pricesOne.style.display = '';
        if (pricesSub) pricesSub.style.display = 'none';
        if (sellingPlanInput) sellingPlanInput.disabled = true;
        if (atcText) atcText.textContent = 'Add to Cart';
        NpAnalytics.track('toggle_onetime', { product: card.dataset.productHandle });
      });
    });
  }
}


/* ===========================================
   5. ADD TO CART CONTROLLER (FLUX-native)
      Direct-to-checkout flow preserved
   =========================================== */
class NpAddToCart {
  constructor() {
    this.forms = document.querySelectorAll('[data-add-form]');
    this.init();
  }

  init() {
    this.forms.forEach(form => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.handleAdd(form);
      });
    });
  }

  async handleAdd(form) {
    const btn = form.querySelector('[data-add-to-cart]');
    if (!btn || btn.disabled) return;

    btn.classList.add('np-card__atc--loading');
    btn.disabled = true;

    try {
      const formData = new FormData(form);
      const body = {};

      body.id = parseInt(formData.get('id'));
      body.quantity = 1;

      const sellingPlan = form.querySelector('[data-selling-plan-input]');
      if (sellingPlan && !sellingPlan.disabled) {
        body.selling_plan = parseInt(sellingPlan.value);
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [body] })
      });

      if (!response.ok) throw new Error('Cart add failed');

      const card = form.closest('.np-card');
      NpAnalytics.track('add_to_cart', {
        product: card?.dataset.productHandle,
        variant_id: body.id,
        subscription: !!body.selling_plan
      });

      this.updateCartAndCheckout();

    } catch (err) {
      console.error('Add to cart error:', err);
      btn.classList.remove('np-card__atc--loading');
      btn.disabled = false;

      const text = btn.querySelector('[data-atc-text]');
      if (text) {
        const original = text.textContent;
        text.textContent = 'Error - try again';
        setTimeout(() => { text.textContent = original; }, 2000);
      }
    }
  }

  updateCartAndCheckout() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden], .header__cart-count').forEach(el => {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('.cart-count-bubble').forEach(el => {
          el.style.display = '';
        });

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));

    var localeMatch = window.location.pathname.match(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i);
        var locale = localeMatch ? localeMatch[0] : '';
        window.location.href = locale + '/checkout';
      })
      .catch(() => {
        var localeMatch = window.location.pathname.match(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i);
        var locale = localeMatch ? localeMatch[0] : '';
        window.location.href = locale + '/checkout';
      });
  }
}


/* ===========================================
   6. QUICK VIEW CONTROLLER
      Preserved but disabled (modal removed from DOM)
   =========================================== */
class NpQuickView {
  constructor() {
    this.modal = document.getElementById('npQuickView');
    if (!this.modal) return;
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-quick-view]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        this.open(trigger.dataset.productHandle);
      }
      if (e.target.closest('[data-close-modal]')) {
        this.close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.getAttribute('aria-hidden') === 'false') {
        this.close();
      }
    });
  }

  async open(handle) {
    this.modal.setAttribute('aria-hidden', 'false');
    this.modal.removeAttribute('data-loaded');
    document.body.style.overflow = 'hidden';

    try {
      const response = await fetch(`/products/${handle}?section_id=main-product`);
      if (!response.ok) throw new Error('Product fetch failed');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const productSection = doc.querySelector('.section-main-product, .product, [data-section-type="main-product"]');

      const body = this.modal.querySelector('[data-modal-content]');
      if (body && productSection) {
        body.innerHTML = productSection.innerHTML;
      }
      this.modal.setAttribute('data-loaded', 'true');

    } catch (err) {
      console.error('Quick view error:', err);
      window.location.href = `/products/${handle}`;
    }
  }

  close() {
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => {
      const body = this.modal.querySelector('[data-modal-content]');
      if (body) body.innerHTML = '';
      this.modal.removeAttribute('data-loaded');
    }, 350);
  }
}


/* ===========================================
   7. ANALYTICS TRACKER
   =========================================== */
class NpAnalytics {
  static track(event, data = {}) {
    if (typeof gtag !== 'undefined') {
      gtag('event', event, {
        event_category: 'Collection',
        ...data
      });
    }

    if (typeof _learnq !== 'undefined') {
      _learnq.push(['track', `Collection ${event}`, data]);
    }
  }
}


/* ===========================================
   8. BUNDLE TIMER + MULTI-ITEM ATC
   ===========================================
   Rolling 24h countdown timer for bundle urgency.
   Multi-item ATC: adds all bundle products sequentially
   then redirects to /discount/CODE?redirect=/checkout
   =========================================== */
class NpBundleController {
  constructor() {
    this.timerEl = document.getElementById('npBundleTimer');
    this.bundleBtns = document.querySelectorAll('[data-bundle-atc]');
    if (!this.timerEl && this.bundleBtns.length === 0) return;
    this.init();
  }

 init() {
    this.initTimer();
    this.bindBundleATC();
  }

  // Extract locale prefix from current URL (e.g. /en-ch, /de-ch, /fr-ch)
  getLocalePrefix() {
    var match = window.location.pathname.match(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i);
    return match ? match[0] : '';
  }

  /* -- Rolling 24h Timer --
     Uses localStorage to persist a consistent end-time per visitor.
     Resets when the timer expires (new 24h window).
     Swap to a fixed date by setting:
       data-bundle-end="2026-03-31T23:59:59" on #npBundleTimer
  */
  initTimer() {
    if (!this.timerEl) return;

    var fixedEnd = this.timerEl.getAttribute('data-bundle-end');
    var endTime;

    if (fixedEnd) {
      endTime = new Date(fixedEnd).getTime();
    } else {
      var stored = null;
      try { stored = localStorage.getItem('np_bundle_timer_end'); } catch(e) {}
      var now = Date.now();

      if (stored && parseInt(stored) > now) {
        endTime = parseInt(stored);
      } else {
        endTime = now + (24 * 60 * 60 * 1000);
        try { localStorage.setItem('np_bundle_timer_end', endTime.toString()); } catch(e) {}
      }
    }

    this.endTime = endTime;
    this.hoursEl = this.timerEl.querySelector('[data-timer-hours]');
    this.minsEl = this.timerEl.querySelector('[data-timer-mins]');
    this.secsEl = this.timerEl.querySelector('[data-timer-secs]');

    this.tickTimer();
    this.timerInterval = setInterval(() => this.tickTimer(), 1000);
  }

  tickTimer() {
    var now = Date.now();
    var diff = Math.max(0, this.endTime - now);

    if (diff <= 0) {
      this.endTime = now + (24 * 60 * 60 * 1000);
      try { localStorage.setItem('np_bundle_timer_end', this.endTime.toString()); } catch(e) {}
      diff = this.endTime - now;
    }

    var totalSecs = Math.floor(diff / 1000);
    var hours = Math.floor(totalSecs / 3600);
    var mins = Math.floor((totalSecs % 3600) / 60);
    var secs = totalSecs % 60;

    if (this.hoursEl) this.hoursEl.textContent = hours.toString().padStart(2, '0');
    if (this.minsEl) this.minsEl.textContent = mins.toString().padStart(2, '0');
    if (this.secsEl) this.secsEl.textContent = secs.toString().padStart(2, '0');

    // Urgency Ribbon: update progress fill width
    if (!this.fillEl) {
      this.fillEl = this.timerEl && this.timerEl.querySelector('[data-timer-fill]');
    }
    if (this.fillEl) {
      var pct = (totalSecs / 86400) * 100;
      this.fillEl.style.width = pct + '%';
    }
  }

  /* -- Multi-Item Bundle ATC --
     Reads variant IDs from data-bundle-variants (comma-separated).
     Adds each item sequentially via /cart/add.js.
     Then redirects to /discount/CODE?redirect=/checkout.
  */
  bindBundleATC() {
    this.bundleBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleBundleAdd(btn);
      });
    });
  }

  async handleBundleAdd(btn) {
    if (btn.disabled) return;

    var variantsStr = btn.getAttribute('data-bundle-variants');
    var discountCode = btn.getAttribute('data-bundle-discount') || '';
    var variantIds = variantsStr.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));

    if (variantIds.length === 0) return;

    // Loading state
    btn.disabled = true;
    btn.classList.add('np-bundle-card__atc--loading');
    var originalHTML = btn.innerHTML;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10" opacity="0.3"/><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/></path></svg> Adding items...';

    try {
      for (var i = 0; i < variantIds.length; i++) {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: variantIds[i],
            quantity: 1,
            properties: {
              '_source': 'protocol_bundle',
              '_bundle': btn.closest('.np-bundle-card')?.querySelector('.np-bundle-card__name')?.textContent || 'Bundle'
            }
          })
        });
        if (!response.ok) throw new Error('Failed to add variant ' + variantIds[i]);
      }

      NpAnalytics.track('bundle_add_to_cart', {
        bundle_name: btn.closest('.np-bundle-card')?.querySelector('.np-bundle-card__name')?.textContent || '',
        variant_ids: variantIds.join(','),
        discount_code: discountCode,
        items_count: variantIds.length
      });

      btn.classList.remove('np-bundle-card__atc--loading');
      btn.classList.add('np-bundle-card__atc--success');
      btn.innerHTML = '&#10003; Redirecting to checkout...';

    var locale = this.getLocalePrefix();
      setTimeout(function() {
        if (discountCode) {
          window.location.href = locale + '/discount/' + discountCode + '?redirect=/checkout';
        } else {
          window.location.href = locale + '/checkout';
        }
      }, 600);

    } catch (err) {
      console.error('Bundle add error:', err);
      btn.classList.remove('np-bundle-card__atc--loading');
      btn.disabled = false;
      btn.innerHTML = originalHTML;

      var errorHTML = btn.innerHTML;
      btn.innerHTML = '&#9888; Error - try again';
      setTimeout(function() { btn.innerHTML = errorHTML; }, 2500);
    }
  }
}


/* ===========================================
   INITIALIZATION
   =========================================== */
document.addEventListener('DOMContentLoaded', () => {
  window.npFilterSort = new NpFilterSort();
  window.npMobileDrawer = new NpMobileDrawer();
  window.npSubscriptionToggle = new NpSubscriptionToggle();
  window.npAddToCart = new NpAddToCart();
  window.npQuickView = new NpQuickView();
  window.npBundleController = new NpBundleController();
});

// Reinitialize on Shopify section reload (Theme Editor)
document.addEventListener('shopify:section:load', () => {
  window.npFilterSort = new NpFilterSort();
  window.npMobileDrawer = new NpMobileDrawer();
  window.npSubscriptionToggle = new NpSubscriptionToggle();
  window.npAddToCart = new NpAddToCart();
  window.npQuickView = new NpQuickView();
  window.npBundleController = new NpBundleController();
});